// Create initial state

export type State = {
  committees: Record<string, any>[];
};
export const state: State = {
  committees: [],
};
